import VideoPlaylistFactory from './video-playlist-factory';

const videoPlaylistFactoryConfig = {
  name: 'videoPlaylistFactory',
  class: VideoPlaylistFactory,
  querySelector: {
    playerWrapper: '.video-playlist__player',
  },
  querySelectorAll: {
    articles: '.article-list__article',
    articleTitles: '.article-list__article-title',
  },
  options: {
    playingClass: 'now-playing',
    upNextClass: 'up-next',
    iconTextClass: 'article-list__article-mediaicon-text',
  },
};

export default videoPlaylistFactoryConfig;
